import * as rq from '@tanstack/react-query';

import { useFeatureFlag } from '@/hooks/use-feature-flag';

import { useDependencies } from '../../contexts/dependencies.context';
import type { ISiteRepository } from '../../domain/repositories/site.repository';

export namespace GetOneSite {
  export const key = (input: Input) => ['records', 'get-one-site', input.id];

  export type Params = { refetchInterval?: number; enabled?: boolean };
  export type Input = Omit<ISiteRepository.GetByIdInput, 'includePcsAlerts'>;
  export type Output = ISiteRepository.GetByIdOutput;

  export function useQuery(
    input: Input,
    { refetchInterval, enabled = true }: Params = {},
  ) {
    const { repositories } = useDependencies();
    const featureFlag = useFeatureFlag();

    return rq.useQuery<Output>({
      refetchInterval,
      enabled,
      queryKey: key(input),
      queryFn: () =>
        repositories.site.getById({
          ...input,
          includePcsAlerts: featureFlag('pcs'),
        }),
    });
  }
}
